import { apiClient } from '@/api/client';
import { Filter } from '@/api/models';
import { useEntityDrawer } from '@/hooks/useEntityDrawer';
import { queryKeys } from '@/lib/queryKeys';
import { FilterFormData } from '@/pages/filters/hooks/useFilterMutations';
import * as React from 'react';
import { FilterDrawerView } from './FilterDrawerView';

export interface FilterDrawerProps {
  onFormSubmit: (formData: FilterFormData) => Promise<void>;
  onDeleteFilter: (filter: Filter) => void;
  isFormLoading: boolean;
}

export const FilterDrawer: React.FC<FilterDrawerProps> = ({
  onFormSubmit,
  onDeleteFilter,
  isFormLoading,
}) => {
  const { state, actions, isLoading } = useEntityDrawer<Filter>({
    basePath: '/filters',
    queryKey: queryKeys.ADMIN_FILTERS,
    fetchFn: async (id: number) => {
      const response = await apiClient.GET('/admin/filters/{id}', {
        params: { path: { id } },
      });
      if (response.error) throw new Error('Failed to fetch filter');
      return response.data as Filter;
    },
    supportsCreate: true,
  });

  return (
    <FilterDrawerView
      isOpen={state.isOpen}
      filter={state.entity}
      mode={state.mode}
      isLoading={isLoading}
      isFormLoading={isFormLoading}
      onClose={actions.close}
      onEdit={filter => actions.edit(filter.id!)}
      onDelete={onDeleteFilter}
      onFormSubmit={onFormSubmit}
    />
  );
};
